module.exports = {"510106024":"西安路街道","510106025":"西华街道","510106027":"荷花池街道","510106030":"驷马桥街道","510106031":"茶店子街道","510106032":"抚琴街道","510106035":"九里堤街道","510106036":"五块石街道","510106038":"营门口街道","510106040":"金泉街道","510106041":"沙河源街道","510106042":"天回镇街道","510106043":"凤凰山街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510106.json
// module id = 2384
// module chunks = 0